// -----------------------------------------------------------------------------
// People Plus AI Routes Constants
// Centralized route paths for PAIC module navigation
// -----------------------------------------------------------------------------

export const PAIC_ROUTES = {
  MAIN: "/people+ai",
  AGENT_LIBRARY: "/people+ai/agent-library",
  GROUP_AGENTS: "/people+ai/pac-group-agents",
  AGENT_DETAILS: "/people+ai/pac-group-agents/agent-details",
  ROLE_IMPACT: "/people+ai/pac-group-agents/role-impact",
  ROLE_IMPACT_DETAILS: "/people+ai/pac-group-agents/role-impact/details",
  JD_PRD_VIEW: "/pac-jd-prd-view",
  PEOPLE_JD_VIEW: "/pac-people-jd-view",
};

// Helper function to build JD/PRD route with query parameter
export const buildJdPrdRoute = (documentType) =>
  `${PAIC_ROUTES.JD_PRD_VIEW}?defaultType=${documentType}`;
